import ReactECharts from 'echarts-for-react';
import React from 'react';

type BarChartProps = {
    name: string,
    data: number[],
    onClick?: () => void,
    expand?: boolean,
    loading?: boolean,
}

export const BarChart = ({
  name,
  data,
  onClick,
  expand,
  loading,
}:BarChartProps) => {

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const option = {
    backgroundColor: 'transparent',
    grid: {
      left: 8,
      right: 12,
      top: expand? 40 : 16,
      bottom: 8,
      containLabel: true, // Ensures labels are displayed within the grid
    },
    xAxis: {
      type: 'category',
      data: ['0-1', '1-2', '2-5', '5-10', '10-15', '15-20', '20+'],
      axisLabel: {
        fontSize: expand? 14 : 10, // Set the font size of the x-axis labels here
        rotate: 0, // Optional: Rotate labels if needed
        interval: 0, // Display all labels
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        fontSize: expand? 14 : 10, // Set the font size of the x-axis labels here
        rotate: 0, // Optional: Rotate labels if needed
        interval: 0, // Display all labels
      },
    },
    series: [
      {
        data: data,
        type: 'bar',
        itemStyle: {
          color: '#059669', // Set the color of the bars here
          borderRadius: [4, 4, 0, 0],
        },
      },
    ],
  };

  return (
    <div
        className={`${loading ? 'animate-pulse' : ''}`}
        onClick={handleClick}>
      { loading ? (
        <div className='h-40 w-full rounded-md bg-gray-300'>
        </div>
      ) : (
        <ReactECharts
            option={option}
            style={{ height: expand ? '220px' : '170px', width: '100%' }}
            opts={{ renderer: 'svg' }}
        />
      ) }
      <p className='text-center text-xs font-bold text-primary-main sm:text-sm'>{ loading ? '' : name }</p>
    </div>
  );
};
